import React, {useState} from 'react';
import {ChakraProvider} from "@chakra-ui/react";
import theme from "./Theme";
import {HashRouter, Navigate, Route, Routes as Switch} from "react-router-dom";
import {Routes} from "./Routes";
import "./assets/scss/app.scss";
import AuthLoginScreen from "./screens/auth/login/AuthLoginScreen";
import {useLocalStorage} from "react-meilleursbiens";
import DashboardScreen from "./screens/dashboard/DashboardScreen";
import {AudioPlayerProvider} from "react-use-audio-player";
import ChooseGenreModal from "./screens/dashboard/components/ChooseGenreModal";

function App() {

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [spotifyToken, setSpotifyToken] = useLocalStorage("spotify_token", null);
    const [genres, setGenres] = useState<string[]>([]);
    const [isChooseGenreModalOpen, setIsChooseGenreModalOpen] = useState<boolean>(false);

    return (
        <ChakraProvider theme={theme}>
            <AudioPlayerProvider>
                <>
                    {!isAuthenticated && (
                        <AuthLoginScreen onLoginComplete={() => {
                            console.log("opening genre modal");
                            setIsChooseGenreModalOpen(true);
                        }}/>
                    )}
                    {isAuthenticated && (
                        <DashboardScreen genres={genres} onLogout={() => setIsAuthenticated(false)}/>
                    )}

                    <ChooseGenreModal isOpen={isChooseGenreModalOpen} onChooseGenre={(genres: string[]) => {
                        setGenres(genres);
                        setIsChooseGenreModalOpen(false);
                        setIsAuthenticated(true);
                    }}/>
                </>
            </AudioPlayerProvider>
        </ChakraProvider>
    );
}

export default App;
